import { Box, Typography } from '@mui/material';
import {
  getUrlRowContainerSx,
  getUrlRowFaviconLetterSx,
  getUrlRowHostTypographySx,
  getUrlRowProgressFillSx,
  urlFeedContainerSx,
  urlRowDoneCheckmarkSx,
  urlRowSpinnerSx,
} from './ScannerAnimation.styles';
import type { UrlRowData } from './types';

function UrlRow({ row }: { row: UrlRowData }) {
  const isActive = row.status === 'active';
  const isDone = row.status === 'done';
  let textColor = '#7a8290';
  if (isActive) {
    textColor = '#111418';
  } else if (isDone) {
    textColor = '#b0b6be';
  }

  return (
    <Box sx={getUrlRowContainerSx(isActive)}>
      <Box sx={getUrlRowProgressFillSx(isActive)} />
      <Box sx={getUrlRowFaviconLetterSx(row.color)}>
        {row.host.charAt(0).toUpperCase()}
      </Box>
      <Typography noWrap sx={getUrlRowHostTypographySx(textColor)}>
        {row.host}
      </Typography>
      {isActive && <Box sx={urlRowSpinnerSx} />}
      {isDone && <Typography sx={urlRowDoneCheckmarkSx}>✓</Typography>}
    </Box>
  );
}

export function UrlFeed({ rows }: { rows: UrlRowData[] }) {
  return (
    <Box sx={urlFeedContainerSx}>
      {rows.map((row, i) => {
        return <UrlRow key={i} row={row} />;
      })}
    </Box>
  );
}
